import { Component, computed, inject, signal } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { LoadingService } from 'src/app/services/loading.service';
import { AuthService } from 'src/app/services/auth.service';
import { UsuarioService } from 'src/app/services/usuario.service';

@Component({
    selector: 'app-acerca-de',
    templateUrl: './acerca-de.component.html',
    styleUrls: ['./acerca-de.component.css'],
    standalone: false
})
export class AcercaDeComponent {
  private router = inject(Router);
  private _location = inject(Location);
  private _authService = inject(AuthService);
  private _loadingService = inject(LoadingService);
  private _usuarioService = inject(UsuarioService);

  // ===== estado (signals) =====
  error = signal<string>('');
  dataUser: any;
  idPerfil = computed(() => this._usuarioService.usuario().id_perfil ?? 2);

  constructor(){

  }

  async ngOnInit(): Promise<void> {
    document.documentElement.scrollTop = 0;

    // Si necesitás (re)cargar usuario/cliente desde backend, hacelo bajo el loader:
    await this._loadingService.run(async () => {
      try {
        // Asegura bootstrap de sesión (idempotente, ok en web/nativo)
        await this._authService.ensureSession();
      } catch (e: any) {
        console.error(e);
        this.error.set(e?.message || 'No se pudo cargar tu cuenta.');
        this.router.navigate(['/sign-in']);
      }
    });
  }

  back(){
    this._location.back();
  }
}
